import { writable } from 'svelte/store';

// This is a simple example where the user is just a boolean,
// but in a real application the user could be an object with
// fields for username, token, etc.
export const user = writable(null);